/**
 * Logo da empresa emissora. Escolhe a versão certa para o fundo:
 * - "dark": fundo escuro (modo lua, capa escura) → logo claro/dourado
 * - "light": papel branco ou modo sol → logo escuro
 * - "cover": capa preta da proposta em preto e branco → versão clara própria, se houver
 * Sem imagem cadastrada, mostra a sigla (como nas prévias).
 */
import { useState } from 'react';
import type { Company } from '@dotapps/core';

let resolve: (path: string | null | undefined) => string | null = p => p ?? null;

/** A interface informa como transformar "/api/public/assets/..." em URL completa. */
export function setAssetResolver(fn: (path: string | null | undefined) => string | null) {
  resolve = fn;
}

export type Surface = 'dark' | 'light' | 'cover';

export function CompanyLogo({ company, size, surface }: { company: Company; size?: 'sm' | 'xs'; surface: Surface }) {
  const [tall, setTall] = useState(false);
  const l = company.logos;
  const src =
    size === 'xs'
      ? surface === 'dark'
        ? (l.markOnDark ?? l.onDark)
        : (l.markOnLight ?? l.onLight)
      : surface === 'cover'
        ? (l.onCover ?? l.onDark)
        : surface === 'dark'
          ? l.onDark
          : (l.onLight ?? l.onDark);
  const url = resolve(src);

  if (url) {
    return (
      <span className={`co-logo img ${size ?? ''}${tall ? ' tall' : ''}`}>
        <img
          src={url}
          alt={company.fantasia}
          crossOrigin="anonymous"
          onLoad={e => {
            const i = e.currentTarget;
            setTall(i.naturalHeight / Math.max(1, i.naturalWidth) > 0.6);
          }}
        />
      </span>
    );
  }
  if (company.estilo === 'mono') {
    return (
      <span className={`co-logo mono ${size ?? ''}`}>
        <span className="om-box">{company.sigla || company.fantasia.slice(0, 2).toUpperCase()}</span>
        <span className="om-word">{company.fantasia.split(' ')[0]}</span>
      </span>
    );
  }
  return (
    <span className={`logo-mark${size ? ' sm' : ''}`}>
      {company.sigla || company.fantasia.slice(0, 3).toUpperCase()}
    </span>
  );
}
